import { Space, List } from "../Layout";
import { Texts, Media, Title, Button } from "../Object";
import { Slide, Scroll } from "../Animation";
const Problem = () => {
  return (
    <>
      <div className="l-row">
        <Texts
          slug="title/problem"
          class="c-text--main c-text--big c-text--en"
        ></Texts>

        <Space size={["64px 0 56px", "48px 0 48px"]}>
          <div className="c-grid__wrap--4-6">
            <Scroll state="left">
              <Texts
                slug="problem/title"
                class="c-text--bold"
              ></Texts>
            </Scroll>
            <Scroll>
              <Texts
                slug="problem/body"
                class="c-text--bold"
              ></Texts>
            </Scroll>
          </div>
        </Space>

        <ul className="c-grid__repeat--4">
          <List Item={Item} length={8} ></List>
        </ul>

      </div>
    </>
  );
};
export default Problem;

export const Item = (props) => {
  return(
    <>
    <Scroll>
      <div className="p-box__items--problem" data-state={props.index}>
        <Media alt="media" class="p-img__problem" src={`problem/list${props.index}`}></Media>
        <Space size={['16px 0 0', '16px 0 0']}>
          <Texts slug={`problem/list${props.index}`} class="c-text--center c-text--bold"></Texts>
        </Space>
      </div>
    </Scroll>
    </>
  )
}